export default __webpack_public_path__ + "static/media/info.e2aa5228.svg";